import TabDetails from './TabDetails';

export default TabDetails;
